module.exports = {
  email: 'sarthakthakkar752@gmail.com',
  resumeLink: 'https://drive.google.com/file/d/1g4gJcZDrbKFIHuEotjTvDAR35X4idmG5/view?usp=drive_link',

  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/SarthakT7',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/sarthak-thakkar-6bb1a9229/',
    },
    {
      name: 'Twitter',
      url: 'https://x.com/Sarthak7502',
    }
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Work',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#ff9640',
    navy: '#111111',
    darkNavy: '#0d0d0d',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
